import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import CircularProgress from '@mui/material/CircularProgress';
import './CustomLoader.scss';

let toggleLoader: (visible: boolean) => void;

export function showLoader() {
	toggleLoader?.(true);
}
export function hideLoader() {
	toggleLoader?.(false);
}

export const LoaderPortal = () => {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		toggleLoader = setVisible;
	}, []);

	if (!visible) return null;

	return ReactDOM.createPortal(
		<div className='global-loader-overlay'>
			<CircularProgress size={50} sx={{ color: '#9149ff' }} />
		</div>,
		document.body
	);
};
